export const data = [
	{
		id: 1,
		name: 'Types of Payment Facilities',
		html: 'types-of-payment-facilities.html',
		children: [
			{
				name: 'Test',
				html: 'test.html'
			}
		]
	},
	{
		id: 2,
		name: 'test2',
	},
	{
		id: 3,
		name: 'test3',
	},
];
